// Type-safe environment variable access
// NOTE: use || (not ??) so that empty-string values also fall back to the default
export const env = {
  VITE_API_URL: (import.meta.env.VITE_API_URL as string) || "http://localhost:8001",
  VITE_COPILOTKIT_SERVICE_URL:
    (import.meta.env.VITE_COPILOTKIT_SERVICE_URL as string) || "http://localhost:3001/api/v1/copilotkit",
  VITE_CLERK_PUBLISHABLE_KEY: (import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string) || "",
  VITE_POSTHOG_PROJECT_TOKEN: (import.meta.env.VITE_POSTHOG_PROJECT_TOKEN as string) || "",
  VITE_TURNSTILE_SITE_KEY: (import.meta.env.VITE_TURNSTILE_SITE_KEY as string) || "",
  VITE_POSTHOG_HOST: (import.meta.env.VITE_POSTHOG_HOST as string) || "",
  VITE_APP_ENV: (import.meta.env.VITE_APP_ENV as string) || "dev",
  VITE_APP_VERSION: (import.meta.env.VITE_APP_VERSION as string) || "",
} as const
